<script setup>

</script>

<template>
<!--  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="m5 14l3.5 3.5L19 6.5"/>
  </svg>-->
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check-icon lucide-check">
    <path d="M20 6 9 17l-5-5"/>
  </svg>
</template>

<style scoped lang="scss">

</style>